<template>
  <div v-if="page">
    <top path="/scheduling/apply">
      <Icon type="ios-arrow-back" slot="left" @click="toLeft" />
      <p slot="center">{{ title }}</p>
    </top>
    <div id="mylist" style="padding: 20px">
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="用车人" prop="user">
              <Input v-model="item.user" placeholder="请输入用车人"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="联系方式" prop="tel">
              <Input
                v-model="item.tel"
                maxlength="11"
                show-word-limit
                placeholder="请输入用车人手机号"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="用车单位" prop="groupName">
              <Input
                v-model="item.groupName"
                placeholder="请输入用车单位"
                @on-focus="openSelectGroup = true"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="用车人数" prop="number">
              <InputNumber
                :max="10"
                :min="1"
                v-model="item.number"
                @on-blur="item.number = Math.round(item.number)"
                placeholder="请输入用车人数"
                style="width: 100%"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="出发地点" prop="startAdd">
              <Input
                v-model="item.startAdd"
                placeholder="请输入出发地"
                @on-focus="openWindow(1)"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="送达地点" prop="endAdd">
              <Input
                v-model="item.endAdd"
                placeholder="请输入送达地点"
                @on-focus="openWindow(2)"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="预计用车" prop>
              <div class="input" @click="openPicker(0)">
                {{ utils.time(item.planUseTime) }}
              </div>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="预计还车" prop>
              <div class="input" @click="openPicker(1)">
                {{ utils.time(item.planReturnTime) }}
              </div>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="用车事由" prop="des">
              <Input
                v-model="item.des"
                maxlength="30"
                show-word-limit
                placeholder="请输入用车事由"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button type="primary" long @click="addUpdateApply('item')"
                >立即提交</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </div>
    <Modal v-model="screen" fullscreen footer-hide>
      <p style="margin-bottom: 20px">请输入搜索内容</p>
      <template>
        <AutoComplete
          element-id="startInput"
          v-model="item.startAdd"
          @on-select="selectAddress"
          @on-search="autoInput"
          @on-focus="item.adds = []"
          clearable
          placeholder="如：深圳北站"
          v-if="item.modal == 1"
        >
          <Option
            v-for="(item, index) in item.adds"
            :value="item.adname + item.name"
            :key="index"
          >
            <span style="color: #999">{{ item.adname }}</span>
            <span style="color: #333">{{ item.name }}</span>
          </Option>
        </AutoComplete>
        <AutoComplete
          element-id="endInput"
          v-model="item.endAdd"
          @on-select="selectAddress"
          @on-search="autoInput"
          @on-focus="item.adds = []"
          clearable
          placeholder="如：深圳北站"
          v-if="item.modal == 2"
        >
          <Option
            v-for="(item, index) in item.adds"
            :value="item.adname + item.name"
            :key="index"
          >
            <span style="color: #999">{{ item.adname }}</span>
            <span style="color: #333">{{ item.name }}</span>
          </Option>
        </AutoComplete>
      </template>
    </Modal>
    <Drawer
      title="选择用车单位"
      width="82"
      :closable="false"
      v-model="openSelectGroup"
    >
      <groupTree @group="selectUserGroup"></groupTree>
    </Drawer>
    <mt-datetime-picker
      :startDate="totay"
      :endDate="end"
      ref="picker0"
      type="datetime"
      v-model="item.planUseTime"
      @confirm="handleConfirm"
      class="lycol lycol5"
    ></mt-datetime-picker>
    <mt-datetime-picker
      :startDate="totay"
      :endDate="end"
      ref="picker1"
      type="datetime"
      v-model="item.planReturnTime"
      class="lycol lycol5"
    ></mt-datetime-picker>
  </div>
</template>
<script>
import axios from "axios";
import groupTree from "../common/groupTree.vue";
var addUpdate = 0;
export default {
  data() {
    return {
      treeData: [],
      page: true,
      title: this.$store.state.applyAdd ? "新增申请" : "更改申请", //等于一个不存在的编号
      item: {
        tel: "",
        number: 1,
        adds: [],
        planUseTime: new Date(),
        startAdd: "",
        endAdd: "",
        des: "",
        planReturnTime: new Date(),
        groupId: "", //用车单位
        groupName: "", //用车单位
        modal: 1, //弹窗 1--出发地点  2--送达地点 3--用车单位
      },
      ruleValidate: {
        tel: { required: true, message: "必填项" },
        user: { required: true, message: "必填项" },
        startAdd: { required: true, message: "必填项" },
        endAdd: { required: true, message: "必填项" },
        groupName: { required: true, message: "必填项" },
        number: { required: true, message: "必填项" },
      },
      totay: new Date(Date.now()),
      end:new Date(Date.now()+86400000*30),
      screen: false,
      pickerValue: "2020-01-02 3:14",
      openSelectGroup: false,
    };
  },
  components: {
    groupTree,
  },
  methods: {
    addUpdateApply(name) {
      this.utils.loading(this, "提交中");
      this.$refs[name].validate((valid) => {
        let params = {
          endAdd: this.item.endAdd,
          groupId: this.item.groupId,
          startAdd: this.item.startAdd,
          tel: this.item.tel,
          user: this.item.user,
          //carTypeId: 0,
          des: this.item.des,
          number: this.item.number,
          planReturnTime: this.utils.toSjc(this.item.planReturnTime),
          planUseTime: this.utils.toSjc(this.item.planUseTime),
        };
        if (valid) {
          if (this.$store.state.applyAdd) {
            axios({
              method: "post",
              url: axios.dispatch + "/apply/add",
              data: params,
            }).then((res) => {
              this.$Spin.hide(); //关闭加载
              if (res.data.code != 200) {
                this.$Message.error(res.data.message);
              } else {
                this.$router.push({
                  path: "/scheduling/apply",
                });
                this.$Message.success({
                  content: "申请成功",
                  duration: 2,
                });
              }
            });
          } else {
            this.$Spin.hide(); //关闭加载
            params.applyId = this.item.applyId;
            axios({
              method: "post",
              url: axios.dispatch + "/apply/update",
              data: params,
            }).then((res) => {
              if (res.data.code != 200) {
                this.$Message.error(res.data.message);
              } else {
                this.$router.push({
                  path: "/scheduling/apply",
                });
                this.$Message.success({
                  content: "申请成功",
                  duration: 2,
                });
              }
            });
          }
        }
      });
    },
    //打开地址自动输入面板，或者用车单位
    openWindow(t) {
      //1，2地址输入模式，3用车单位模式
      this.item.modal = t;
      if (t == 1) {
        //this.$refs.start.focus();
        setTimeout(() => {
          document.getElementById("startInput").focus();
        }, 500);
      }
      if (t == 2) {
        //this.$refs.end.focus();
        setTimeout(() => {
          document.getElementById("endInput").focus();
        }, 500);
      }
      this.screen = true;
    },
    // 获取输入提示信息
    autoInput(v) {
      /* if (this.keyword.length < 2) {
        this.carArr = [];
        this.searching = false;
        this.openSelect = false;
        return;
      } */
      let params = {
        keywords: v,
      };
      axios({
        method: "post",
        url: axios.serverWeb + "/map/search",
        data: params,
      }).then((res) => {
        this.searching = false;
        var data = res.data.data;
        this.item.adds = data;
      });
    },
    selectAddress() {
      this.screen = false;
    },
    selectUserGroup(y) {
      this.item.groupId = y.groupId;
      this.item.groupName = y.name;
      this.openSelectGroup = false;
    },
    startChange() {},
    //打开选择器
    openPicker(t) {
      if (t == 0) {
        this.$refs.picker0.open();
      } else {
        this.$refs.picker1.open();
      }
    },
    //点击时间控件，修改开始时间
    handleConfirm(x) {
      // console.log(this.item);
    },
    toLeft() {
      this.$router.push({
        path: "/scheduling/apply",
      });
      // this.$emit("applyId", 1);
      this.$store.state.applyAdd = true;
    },
  },
  mounted() {
    //this.item.planUseTime = this.day(Date.now() + 1 * 60 * 60 * 1000);
    //this.item.planReturnTime = this.day(Date.now() + 1 * 60 * 60 * 1000);
  },
};
</script>
<style lang="">
#mylist .input {
  width: 100%;
  border: solid 1px #ddd;
  padding: 4px 10px;
  height: 30px;
  border-radius: 4px;
}
.ivu-select-dropdown-list {
  height: 200px;
}


</style>


// WEBPACK FOOTER //
// src/components/apply/addApply.vue